import { useRef, useState } from "react";
import Header from "@/components/site/Header";
import { scrollToEl } from "@/lib/scroll";
import Hero from "@/components/site/Hero";
import BrandMarquee from "@/components/site/BrandMarquee";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import Schedule from "@/components/site/Schedule";
import QuickBuys from "@/components/site/QuickBuys";
import Pricing from "@/components/site/Pricing";
import ProgramCompare from "@/components/site/ProgramCompare";
import About from "@/components/site/About";
import SuccessStories from "@/components/site/SuccessStories";
import Testimonials from "@/components/site/Testimonials";
import ClassPassReviews from "@/components/site/ClassPassReviews";
import Referral from "@/components/site/Referral";
import FAQ from "@/components/site/FAQ";
import LeadForm from "@/components/site/LeadForm";
import Footer from "@/components/site/Footer";
import StickyConsult from "@/components/site/StickyConsult";
import WhatsAppButton from "@/components/site/WhatsAppButton";
import ExitIntent from "@/components/site/ExitIntent";
import SchemaMarkup from "@/components/site/SchemaMarkup";

export default function Home() {
  const consultRef = useRef(null);
  const [prefill, setPrefill] = useState(null);
  const scrollToConsult = () => scrollToEl("#consult");

  return (
    <div className="bg-[#050505]" data-testid="home">
      <SchemaMarkup />
      <Header />
      <Hero onConsult={scrollToConsult} />
      <BrandMarquee />
      <Manifesto />
      <Services />
      <Schedule onConsult={scrollToConsult} onSelectPlan={setPrefill} />
      <QuickBuys onConsult={scrollToConsult} onSelectPlan={setPrefill} />
      <Pricing onConsult={scrollToConsult} onSelectPlan={setPrefill} />
      <ProgramCompare />
      <About />
      <SuccessStories onConsult={scrollToConsult} />
      <Testimonials />
      <ClassPassReviews />
      <Referral />
      <FAQ />
      <LeadForm ref={consultRef} prefill={prefill} />
      <Footer onConsult={scrollToConsult} />
      <StickyConsult />
      <WhatsAppButton />
      <ExitIntent />
    </div>
  );
}
